import { API } from 'apis';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { FiatRates } from 'core/domain/fiat/fiat';
import toast from 'react-hot-toast';

export const getAllRates = async (setLoading: any, setData: any) => {
    setLoading(true);
    await getViaAuth<FiatRates[]>(API.fiat.getAll).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            if (response.value) {
                setData(response.value);
            }
        }
    });
};

export const updateRate = async (setLoading: any, data: { symbol: string; buyPrice: number; sellPrice: number }) => {
    setLoading(true);
    await postViaAuth(API.fiat.edit, data)
        .then((response) => {
            if (responseValidator(response.status)) {
                toast.success('نرخ ارز مورد نظر با موفقیت تغییر کرد');
            }
        })
        .finally(() => {
            setLoading(false);
        });
};
